export default {
  data: {
    placeholder: '资料编号/名称查询',
    tabOptions: ['全部', '启用', '开立', '停用'],
    fileTypeOptions: ['图纸', '文件'],
    status: '状态',
    dataNo: '资料编号',
    dataName: '资料名称',
    fileType: '类型',
    fileVersion: '版本',
    packDownload: '附件',
    releaseTime: '发布时间',
    addUserName: '建单人',
    addDeptName: '建单部门',
    addUserPhone: '建单人手机号',
    handleOptions: {
      downLoad: '打包下载',
      release: '发布',
      start: '启用',
      stop: '停用',
      sendRecord: '发放记录'
    },
    dateRange: '发布时间',
    statusOptions: ['启用', '停用'],
    settingTitle: '发放设置',
    transferTitle: ['全部', '已选'],
    fileList: '附件',
    sendRecord: {
      sendStatus: '状态',
      sendStatusOptions: ['已发放', '已取消'],
      supOfficeName: '供应商名称',
      supOfficeNo: '供应商编号',
      operator: '操作人',
      sendOrCancelTime: '发放/取消时间',
      detail: '查阅记录',
      addUserName: '操作人',
      adddate: '操作时间',
      actionType: '状态',
      dialogTitle: '查阅记录',
      actionTypeOptions: ['查看详情', '下载']
    }
  }
}
